// src/data.js

export const projects = [
    {
      id: 1,
      title: "IKEA - Home can wait",
      contents: [
        { type: "text", text: "With restrictions easing, I was tasked to create an OOH campaign to celebrate London coming out of lockdown. The campaign appeared across Underground Zones 1 and 2." },
        { type: "image", src: "/img/ikea/ikea2.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/ikea/ikea1.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/ikea/ikea3.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/ikea/ikea4.jpg", alt: "Extra A image" },
      ]
    },
    {
      id: 2,
      title: "Uniqlo",
      contents: [
        { type: "text", text: "Uniqlo Insight: People are buying less into heavily branded clothing and unlike other big brands, Uniqlo clothing is all unbranded." },
        { type: "text", text: "Activation: The Debranding Service: A service where you can take your branded clothing into Uniqlo stores and get the branding removed." },
        { type: "image", src: "/img/uniqlo/tshirt.jpg", alt: "Extra A image" },
        { type: "text", text: "Print that dramatises the lack of branding:" },

        { type: "image", src: "/img/uniqlo/uniqlo1.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/uniqlo/uniqlo2.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/uniqlo/uniqlo3.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/uniqlo/uniqlo4.jpg", alt: "Extra A image" },
        { type: "text", text: "Activation: The clothes drop hijack. Uniqlo will hijack clothes drops by offering Uniqlo freebies alongside huge queues, diverting people away from branded clothing and towards Uniqlo clothing." },

        { type: "image", src: "/img/uniqlo/queue.jpg", alt: "Extra A image" },
      ]
    },
    {
      id: 4,
      title: "Leyf",
      contents: [
        { type: "text", text: "Insight: LEYF is a social enterprise with 40 nurseries around London and has an ethos that champions risk-taking and creativity. Solution: Show prospective parents how the nurseries think differently so that the children will. The posters ran across London." },
        { type: "image", src: "/img/leyf/5.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/leyf/1.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/leyf/2.png", alt: "Extra A image" },
        { type: "image", src: "/img/leyf/3.jpg", alt: "Extra A image" },
        { type: "image", src: "/img/leyf/4.jpg", alt: "Extra A image" },
      ]
    },
    {
      id: 5,
      title: "London Sock Company",
      contents: [
        { type: "text", text: "When we created this ad, we were heading into lockdown 2.0 and things were looking bleak. It was the little things such as a dash of colour to your wardrobe that offered a moment of joy. Starring Downton Abbey's Michael B Fox, we wanted to showcase how a bright pair of socks can keep the grey at bay." },
        { type: "video", src: "https://www.youtube.com/embed/KGD3SHvLpzk?si=6ilbahFNPzKEYbEz", alt: "London Sock Company Video" }
      ]
    },
    {
      id: 6,
      title: "Duolingo",
      contents: [
        { type: "text", text: "Problem: While Duolingo is a great free app, users need real world experience to consolidate learning on the app." },
        { type: "text", text: "Solution: Duolingo Thursdays works as a partnership with cafes, restaurants and bars where users can have experiences where staff will speak to you in your chosen foreign language." },


        { type: "image", src: "/img/duo/duo1.png", alt: "Sock image 3" },

        { type: "text", text: "The idea democratises language learning because it means that everyone can easily experience a foreign language, not just those who are wealthy enough to travel abroad." },
        { type: "text", text: "Users who want to make it clear that they are taking part can wear the badge." },
        { type: "image", src: "/img/duo/duo2.png", alt: "Sock image 3" },

        { type: "text", text: "Customers can find establishments in their target language via the map. " },
        { type: "image", src: "/img/duo/duo3.jpg", alt: "Sock image 3" },

        { type: "text", text: "Posters inviting customers to put their language skills to the test to get discounts will be put up outside establishments." },
        { type: "image", src: "/img/duo/duo4.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/duo/duo5.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/duo/duo6.jpg", alt: "Sock image 3" },

     
      ]
    },
    {
      id: 7,
      title: "Snug",
      contents: [
        { type: "text", text: "This work for Snug, the original sofa-in-a-box company, showcases the extreme luxury of the brand’s most comfortable range yet: the Cloud Sundae." },
        { type: "video", src: " https://www.youtube.com/embed/PQPu4yeWUSs?si=z-z5VeFFkq5_FqTe", alt: "London Sock Company Video" }
      ]
    },
    {
      id: 8,
      title: "Gravestone Predictor",
      contents: [
        { type: "text", text: "This was a proactive idea I had for Mother Projects during my time there. Unfortunately, it was somewhat close to the bone mid-pandemic so it became a back pocket idea.            " },
        { type: "image", src: "/img/grave/grave1.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/grave/grave2.jpg", alt: "grave" },
        { type: "image", src: "/img/grave/grave4.jpg", alt: "grave" },
        { type: "image", src: "/img/grave/grave5.jpg", alt: "grave" },
        { type: "image", src: "/img/grave/grave6.jpg", alt: "grave" },
      ]
    },
    {
      id: 9,
      title: "Notepad",
      contents: [
        { type: "text", text: "Having ideas is easy. All you do is stare at a blank sheet of paper until drops of blood form on your forehead. Everyone knows that the blank page is the worst part of the creative process; the first hurdle to confront when trying to create something new. Introducing the Doodled Pad: the notepad with scribbles, drawings and doodles from inspirational designers, writers and creatives so you never have that intimidating blank page staring back at you." },
        { type: "image", src: "/img/notepad/pad1.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/notepad/pad2.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/notepad/pad3.jpg", alt: "Sock image 3" },
        { type: "image", src: "/img/notepad/pad4.jpg", alt: "Sock image 3" },

        { type: "image", src: "/img/notepad/pad5.jpg", alt: "Sock image 3" },
      ]
    },
    {
        id: 10,
        title: "Ryman",
        contents: [
          { type: "text", text: "Insight: Cheap stationery takes the pressure off writing, producing better work than you would with more expensive brands." },
          { type: "text", text: "Solution: Show how it's better to spend less on stationery." },

          { type: "image", src: "/img/ryman/ryman1.jpg", alt: "Sock image 3" },
          { type: "image", src: "/img/ryman/ryman2.jpg", alt: "Sock image 3" },
          { type: "image", src: "/img/ryman/ryman3.jpg", alt: "Sock image 3" },
          { type: "text", text: "Activation: The Ryman Museum. Ryman will gather all the notebooks which have lead to famous ideas and exhibit them." },

          { type: "image", src: "/img/ryman/ryman4.jpg", alt: "Sock image 3" },

        ]
      },

      {
        id: 11,
        title: "Creative Feat",
        contents: [
          { type: "text", text: "If there’s one thing that Creative Directors have in common, it’s that getting it right when it comes to footwear is of high sartorial importance. So much so, that you might even be able to tell who your Creative Director is just by looking at their shoes." },
          { type: "text", text: "So I captured Creatives' feet at Havas and then invited viewers to guess whose shoes belonged to who." },
          { type: "text", text: "The project garnered over 3000 media impressions." },

          { type: "image", src: "/img/cdshoes/1.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/2.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/3.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/4.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/5.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/6.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/7.JPG", alt: "Sock image 3" },

        ]
      },

      {
        id: 12,
        title: "EE Stay Connected",
        contents: [
          { type: "text", text: "Safe commuting is a major issue especially for students traveling home alone at night. EE wanted to tackle the issue." },
          { type: "text", text: "Taking over Manchester, one of the UK's biggest student cities, EE Stay Connected used live travel data, AR and lighting technology to help Manchester students plan and track journeys home or to safe spaces." },
          { type: "text", text: "The campaign won the Ocean Outdoor prize." },

          { type: "image", src: "/img/cdshoes/1.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/2.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/3.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/4.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/5.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/6.JPG", alt: "Sock image 3" },
          { type: "image", src: "/img/cdshoes/7.JPG", alt: "Sock image 3" },

        ]
      },

      {
        id: 13,
        title: "Ben & Jerry's Doorstep Delight",
        contents: [
          { type: "text", text: "To create a buzz around Ben & Jerry’s ice cream delivery service, I whipped up some fun and silly social ads to get the word out..." },
          { type: "text", text: "From football fever during the Euros, to sizzling summer heat, I served up timely content all year round to make ice cream relevant to every calendar moment." },
          { type: "text", text: "The result? A parade of pun-packed ads that had people reaching for their phones. Because why wait when you can have ice cream delivered to your door?" },

          { type: "image", src: "/img/benjerrys/social1.png", alt: "Ben & Jerry's 1" },
          { type: "image", src: "/img/benjerrys/social2.png", alt: "Ben & Jerry's 2" },
          { type: "image", src: "/img/benjerrys/social3.png", alt: "Ben & Jerry's 3" },

        ]
      },
      {
        id: 14,
        title: "EE X Samsung Gallaxy",
        contents: [
          { type: "text", text: "With the Samsung 23's great camera and huge storage capacity, you can truly snap away your every experience. So I was tasked with taking images on the phone to weave into stop motion sequences around the capital to show how you won't have to miss a second. Project for Saatchi & Saatchi." },
          { type: "image", src: "/img/ee/caroussel.gif", alt: "caroussel" },
          { type: "image", src: "/img/ee/theatre.gif", alt: "theatre" },
          { type: "image", src: "/img/ee/stairs.gif", alt: "Stairs" },

        ]
      },
  ];
  
  export const extraLightboxes = [
  
    {
      id: 901,
      title: "Contact",
      buttonLabel: "Contact",
      contents: [
        {
          type: "html",
          html: `
            <ul class="awards-list">
              <li><strong>Email: </strong>isabellejohnson826@gmail.com</li>
          <li><strong>Company site: </strong>
    <a href="https://newworldcreative.studio" target="_blank" rel="noopener noreferrer" className="link-style">
      newworldcreative.studio
    </a>                        
  </ul>
          `
        },
        {
          type: "html",
          html: `
            <ul class="awards-list">
<li><strong>Photo site: </strong>
    <a href="https://isabellejohnsonphoto.com" target="_blank" rel="noopener noreferrer" className="link-style">
      isabellejohnsonphoto.com
    </a>
  </li>            
  </ul>
          `
        },

      ]
    },
    {
      id: 902,
      title: "Awards & Press",
      buttonLabel: "Awards & Press",
      contents: [
        { type: "text", text: "Some awards..." },
        {
          type: "html",
          html: `
            <ul class="awards-list">
              <li><strong>British Arrows</strong>5x Nomination</li>
              <li><strong>Ocean Digital Creative Competition</strong>First Prize, 2022</li>
              <li><strong>Campaign Media Awards</strong>Gold</li>
              <li><strong>Cream 2020</strong> Winner</li>
              <li><strong>Cream 2021</strong> Winner</li>
              <li><strong>The Drum Awards</strong>Innovation Award</li>
              <li><strong>Visionary Arts Awards TV</strong>Nomination</li>

            </ul>
          `
        },
        { type: "text", text: "Press..." },
        {
          type: "html",
          html: `
            <ul class="awards-list">
              <li><strong>The Drum Ad of the Day</strong></li>
              <li><strong>Campaign Magazine</strong></li>
              <li><strong>The Mirror</strong></li>
              <li><strong>The Daily Mail</strong></li>
              <li><strong>Edinburgh News</strong></li>
              <li><strong>Refinery29</strong></li>
              <li><strong> The Scotsman</strong></li>
              <li><strong>Elle France</strong></li>
              <li><strong>Vogue UK</strong></li>
            </ul>
          `
        },
      ]
    },
    {
        id: 903,
        title: "Etc",
        buttonLabel: "Etc",
        contents: [

          { type: "text", text: "I always have a creative project on the go. Below are just a few. I am a member of the Association of Photographers and love to combine photography and illustration." },
          { type: "image", src: "/img/flowers/flower1.JPG", alt: "flower1" },
          { type: "image", src: "/img/flowers/flower2.jpg", alt: "flower 2" },
          { type: "image", src: "/img/flowers/flower3.jpg", alt: "flower 3" },
          { type: "image", src: "/img/illustration.jpeg", alt: "Extra A image" },
          { type: "image", src: "/img/snake.png", alt: "Extra A image" },
          {
            type: "html",
            html: `
              <ul class="awards-list">
            <li><strong>View more Projects on my Instagram: </strong>
      <a href="https://www.instagram.com/issyj1/?hl=en-gb" target="_blank" rel="noopener noreferrer" className="link-style">
        @issyj1
      </a>                       
    </ul>
         `
          },
        ]
      },
    
  ];
  
  export const bottomButtons = [
    {
      id: 'bottom1',
      buttonLabel: 'Need a website?',
      title: 'Need a website?',
      contents: [
        { type: 'text', text: 'I will build you a site and the contents to fill it' },
        { type: 'image', src: '/img/bottom1.jpg', alt: 'Bottom image 1' },
      ],
    },
    {
      id: 'bottom2',
      buttonLabel: '+',
      title: 'Bottom Lightbox 2',
      imageSrc: '/adfolio/img/portrait/431A8453.jpg', alt: 'Profile icon',
      contents: [
        { type: 'text', text: 'Content for bottom lightbox 2' },
      ],
    },
    {
        id: 'bottom2',
        buttonLabel: 'Etc',
        title: 'Bottom Lightbox 2',
        contents: [
          { type: 'text', text: 'Content for bottom lightbox 2' },
        ],
      },
      {
        id: 902,
        title: "Etc",
        buttonLabel: "Etc",
        contents: [
          { type: "text", text: "I always have a creative project on the go. Below are just a few." },
          { type: "image", src: "/img/illustration.jpeg", alt: "Extra A image" },
          { type: "text", text: "I always have a creative project on the go. Below are just a few." },
        ]
      },
  ];
  
